import React, { useId } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'hooks';
import Transition from '../../Transition';
import FilterDialogActions from './FilterDialogActions';

interface FilterDialogProps {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
  onResetAll: () => void;
  children?: React.ReactNode;
}

const FilterDialog = ({
  open,
  onClose,
  children,
  onApply,
  onResetAll,
}: FilterDialogProps) => {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      aria-labelledby={titleId}
      fullScreen
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          minHeight: 52,
          flexShrink: 0,
          bgcolor: 'common.white',
          boxShadow: '0 2px 8px rgb(0 0 0 / 8%)',
          zIndex: 1,
        }}
      >
        <Typography
          id={titleId}
          component="h2"
          sx={{ flex: 1, fontSize: 18, fontWeight: 700 }}
        >
          {t('filters')}
        </Typography>
        <Button
          onClick={onResetAll}
          data-testid="resetFiltersAll"
          sx={{
            minHeight: 40,
            flexShrink: 0,
            color: 'text.secondary',
            fontWeight: 600,
            letterSpacing: '0.5px',
          }}
        >
          {t('resetAll')}
        </Button>
        <IconButton
          onClick={onClose}
          aria-label={t('close')}
          edge="end"
          sx={{ color: 'text.primary' }}
        >
          <Close />
        </IconButton>
      </Box>
      <DialogContent
        sx={{ minHeight: 0, p: 2, bgcolor: 'var(--background-default)' }}
      >
        {children}
      </DialogContent>
      <FilterDialogActions onApply={onApply} />
    </Dialog>
  );
};

export default FilterDialog;
